import React from "react";
import Icon from "./Icon";

/**
 * A disclosure list built on <details>/<summary>, with the browser's
 * default triangle removed and replaced by a chevron that rotates.
 *
 * Still <details> underneath rather than a div with onClick, because that
 * gets keyboard operation, the correct ARIA semantics, and in-page find
 * (Chrome expands a closed <details> when the search text is inside it)
 * for free — all things a hand-rolled accordion has to reimplement and
 * usually doesn't.
 *
 * `name` groups them so opening one closes the others where the browser
 * supports it, and degrades to independent toggles where it doesn't.
 */
export default function Faq({ items, name = "faq", title = "Frequently asked questions", id = "faq-heading" }) {
  if (!items || !items.length) return null;

  return (
    <section className="faq" aria-labelledby={id}>
      <h2 id={id}>{title}</h2>
      <div className="faq-list">
        {items.map((item, i) => (
          <details className="faq-item" key={i} name={name}>
            <summary>
              <span className="faq-question">{item.q}</span>
              <Icon name="chevron" className="faq-chevron" />
            </summary>
            <div className="faq-answer">
              <p>{item.a}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
